export default "__VITE_ASSET__Chb9KNHM__"